import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import HomePage from "./pages/HomePage";
import ChapterSelection from "./pages/ChapterSelection";
import QuizPage from "./pages/QuizPage";
import ResultPage from "./pages/ResultPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminReportsNew from "./pages/AdminReportsNew";
import DatabaseManagerPage from "./pages/DatabaseManagerPage";
import WordMeaningChapters from "./pages/WordMeaningChapters";
import WordMeaningPageSelection from "./pages/WordMeaningPageSelection";
import WordMeaningAdmin from "./pages/WordMeaningAdmin";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/chapters/:subjectId" element={<ChapterSelection />} />
          <Route path="/quiz" element={<QuizPage />} />
          <Route path="/result" element={<ResultPage />} />
          <Route path="/word-meaning/chapters/:subjectId" element={<WordMeaningChapters />} />
          <Route path="/word-meaning/pages/:chapterId" element={<WordMeaningPageSelection />} />
          <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/reports" element={<AdminReportsNew />} />
          <Route path="/admin/database" element={<DatabaseManagerPage />} />
          <Route path="/admin/word-meaning" element={<WordMeaningAdmin />} />
          {/* 404 Catch-all: Redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
